export default "__VITE_ASSET__bd740de8__"